import useCookie from '~/shared/hooks/useCookie';

const useCid = () => useCookie<string>('cid');

export default useCid;
